export enum Uprawnienie {
  wykonawca,
  administrator,
  system,
  pracownikKlienta,
  wykonawcaPlus,
}
